import { z } from 'zod';
import { IAsset } from './IAsset';
import { IAssetCategoryId } from './IAssetCategory';
import { IAssetTypeId } from './IAssetType';
import { GenericAssetSchema } from './IGenericAsset';

export const DepotAssetVersion = {
  Initial: 1,
} as const;

export type DepotAssetVersion =
  (typeof DepotAssetVersion)[keyof typeof DepotAssetVersion];

export function getEmptyDepotAsset(idAsset: number): IDepotAsset {
  return {
    idAsset,
    idAssetType: IAssetTypeId.Depot,
    idAssetCategory: IAssetCategoryId.PersonalProperty,
    Version: DepotAssetVersion.Initial,
    data: {
      value: 0,
      brokerName: '',
      depotNumber: '',
      notes: '',
    },
  };
}

export function isDepotAsset(asset: IAsset): asset is IDepotAsset {
  return asset.idAssetType === IAssetTypeId.Depot;
}

export const DepotAssetDataSchema = z.object({
  value: z.number(), // gesamtwert
  brokerName: z.string(),
  depotNumber: z.string(),
  notes: z.string().optional(),
});

export const DepotAssetSchema = GenericAssetSchema(
  z.literal(IAssetTypeId.Depot),
  z.literal(IAssetCategoryId.PersonalProperty),
  z.literal(DepotAssetVersion.Initial).optional(),
  DepotAssetDataSchema
);

export type IDepotAsset = z.infer<typeof DepotAssetSchema>;
